import JwtService from "../services/jwt-service";
import axiosInstance from "../plugins/axios-plugin";
import AuthService from "../services/auth-service";
import router from "../router";
import UserService from "../services/user-service";
import { notifyError } from "../services/notifications";

export default {
  namespaced: true,
  state: {
    isAuthenticated: !!JwtService.getToken(),
    user: UserService.getUser(),
    isAdmin: UserService.isAdmin()
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    isAdmin: state => state.isAdmin,
    user: state => state.user
  },
  actions: {
    checkToken: ({commit}) => {
      commit('setAuthenticated', !!JwtService.getToken())
    },
    signIn: async ({ commit }, payload) => {
      try {
        const response = await axiosInstance.post('/auth/login', payload)
        AuthService.saveData(response.data)
        commit('setAuthenticated', true)
        commit('setUser', response.data.user)
        commit('setAdmin', UserService.isAdmin())
        await router.push({name: 'dashboard'})
      } catch (error) {
        notifyError(error.message)
      }
    },
    signOut: async ({ commit }) => {
      AuthService.destroyData()
      commit('setAuthenticated', false)
      commit('setAdmin', false)
      await router.push({name: 'sign-in'})
    }
  },
  mutations: {
    setAuthenticated: (state, payload) => {
      state.isAuthenticated = payload
    },
    setAdmin: (state, payload) => {
      state.isAdmin = payload
    },
    setUser: (state, payload) => {
      state.user = payload
    }
  }
}
